import React from "react";
import { MdOutlineEmail } from "react-icons/md";
import { FiPhone } from "react-icons/fi";
import { HiOutlineLocationMarker } from "react-icons/hi";

const ContactSection = () => {
    return (
        <section className="row mx-0 d-flex justify-content-center my-5">
            <div className="col-12 col-md-10">
                <div className="row mb-5">
                    <div className="col-12 col-md-8">
                        <h6 className="fs-14">Tagline</h6>
                        <h1 className="mt-2">Contact us</h1>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </p>
                    </div>
                </div>
                <div className="row text-start">
                    <div className="col-12 col-md-4 mb-4">
                        <MdOutlineEmail size={28} className="mb-3" />
                        <h5>Email</h5>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            Suspendisse varius enim in ero.
                        </p>
                        <p>hello@datacode.com</p>
                    </div>

                    <div className="col-12 col-md-4 mb-4">
                        <FiPhone size={28} className="mb-3" />
                        <h5>Phone</h5>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            Suspendisse varius enim in ero.</p>
                        <p>+91 (800) 123-4567</p>
                    </div>
                    <div className="col-12 col-md-4 mb-4">
                        <HiOutlineLocationMarker size={28} className="mb-3" />
                        <h5>Office</h5>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            Suspendisse varius enim in ero. </p>
                        <p>
                            123 Sample St, Sydney NSW 2000 AU
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
